export default __webpack_public_path__ + "static/article-four-steps-to-funding-your-dream-wedding-828fa99b8a6e9ff4febd736c86220995.jpg";